/**
 * A felcsúszó lap fogantyúja — a kis vízszintes csík a lap tetején (Geri,
 * #71). Jelzi, hogy ez egy lecsukható lap, és egérrel ezen fogva húzható le
 * (`useSwipeToClose`, `data-sheet-grip`). Érintéssel az egész lap húzható.
 */
export function SheetGrip() {
  return <span className="sheet-grip" data-sheet-grip aria-hidden="true" />;
}
